import React from 'react';
import {FormValidator} from '../../util/form-validator';
import GIEButton from '../../components/GIEButton/GieButton';
import EquipmentChoice from '../../components/EquipmentChoice/EquipmentChoice';
import EquipmentCard from '../../components/EquipmentChoice/EquipmentCard';
import YourAskingForm from './YourAskingForm';
import InputLabel from "@material-ui/core/InputLabel";
import {FormControl} from "@material-ui/core";

export default class YourAsking extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();
  askingForm: any;

  constructor(props: any) {
    super(props);
    this.state = {
      gearChanged: false,
      formControls: {
        brand: {
          value: '',
          error: false,
          errorMessage: ''

        },
        model: {
          value: '',
          error: false,
          errorMessage: ''

        },
        year: {
          value: '',
          error: false,
          errorMessage: ''

        },
        installYear: {
          value: '',
          error: false,
          errorMessage: ''

        },
        gear: {
          value: '',
          error: false,
          errorMessage: ''

        }
      }
    }
    this.checkValidForm = this.checkValidForm.bind(this)
    this.askingForm = React.createRef();
  }

  gearChanged = (isChanged: boolean) => {
    this.setState({gearChanged: isChanged})
  }

  changeHandler = (formControls) => {
    formControls.gear = this.state.formControls.gear;
    this.setState({formControls})
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    let isError = false;
    Object.keys(formControls).forEach(name => {
      const error = this.formValidator.returnError(formControls[name].value, name)
      formControls[name].error = error.error;
      formControls[name].errorMessage = error.errorMessage;
      if (error.error === true) {
        isError = true
      }
    });
    this.askingForm.current.checkValidForm();
    this.setState(formControls)
    return isError;
  }

  next = () => {
    if (this.state.gearChanged === false) {
      this.props.next(this.state)
    } else if (this.checkValidForm() === false) {
      this.props.next(this.state);
    }
  }

  changeGear = (value) => {
    this.setState({
      formControls: {
        ...this.state.formControls,
        gear: {
          ...this.state.formControls.gear,
          value,
          error: false,
          errorMessage: ''
        }
      }
    });
  }

  render() {
    return (
      <div>
        <FormControl variant="outlined" fullWidth margin="normal" className="mt-4">
          <InputLabel id="equipment-lbl" shrink disableAnimation className="gie-label" required>
            Votre équipement à entretenir a-t-il changé ?
          </InputLabel>
          <div className="row g-4 pt-2">
            <EquipmentCard emit={() => this.gearChanged(true)}
                           className="col-6"
                           title="Oui"
                           checked={this.state.gearChanged}/>
            <EquipmentCard emit={() => this.gearChanged(false)}
                           className="col-6"
                           title="Non"
                           checked={!this.state.gearChanged}/>
          </div>
        </FormControl>

        {this.state.gearChanged &&
          <div>
            <EquipmentChoice title="Quel équipement souhaitez-vous entretenir ?"
                             gearError={this.state.formControls.gear.error} emit={this.changeGear}/>
            <YourAskingForm ref={this.askingForm} emit={(formControls) => this.changeHandler(formControls)}/>
          </div>}
        <div className="text-center my-4">
          <GIEButton onClick={this.next} classes={{root: 'blue-btn'}}>Suivant</GIEButton>
        </div>
      </div>
    );
  }
}
